import { Text } from "@mantine/core";
import classes from "./ContactIcons.module.css";
import { ReactNode } from "react";
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandLinkedin,
} from "@tabler/icons-react";
import { useTranslation } from 'react-i18next';

interface SocialLink {
  icon: ReactNode;
  link: string;
}

interface ContactIconProps
  extends Omit<React.ComponentPropsWithoutRef<"div">, "title"> {
  title: React.ReactNode;
  description?: React.ReactNode;
  socials?: SocialLink[];
}

export function ContactIcon({
  title,
  description,
  socials,
  ...others
}: ContactIconProps) {
  const content = (
    <div className={classes.wrapper} {...others}>
      <div className={classes.body}>
        <Text size="xs" className={classes.title}>
          {title}
        </Text>
        {description && (
          <Text className={classes.description}>{description}</Text>
        )}
        {socials && socials.length > 0 && (
          <div className={classes.iconGroup}>
            {socials.map(({ icon, link }, index) => (
              <a
                key={index}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.iconLink}
              >
                <div className={classes.icon}>{icon}</div>
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  return content;
}

export function ContactIconsList() {
    const { t } = useTranslation();

    const MOCKDATA = [
        { 
          title: t('contactUs.sub1Title'),
          description: t('contactUs.sub1Data'),
        },
        {
          title: t('contactUs.sub2Title'),
          description: t('contactUs.sub2Data'),
        },
        {
          title: t('contactUs.sub3Title'),
          socials: [
            {
              icon: <IconBrandFacebook />,
              link: "https://www.facebook.com/domaxcredit",
            },
            {
              icon: <IconBrandInstagram />,
              link: "https://www.instagram.com/domax.credit",
            },
            {
              icon: <IconBrandLinkedin />,
              link: "https://www.linkedin.com/company/domax-sdn-bhd",
            },
          ],
        },
    ];

  const items = MOCKDATA.map((item, index) => (
    <ContactIcon key={index} {...item} />
  ));
  return <div className={classes.contactContainer}>{items}</div>;
}
